export default __webpack_public_path__ + "static/media/App.574a9891.less";